import React from 'react';
import { motion } from 'framer-motion';
import { BookOpen, CalendarDays, Quote } from 'lucide-react';
export function WhatYouGetSection() {
  const items = [{
    title: 'El Código del Cierre™',
    desc: 'Guía principal en PDF con 21 rituales simbólicos para ayudarte a cerrar ciclos emocionales, soltar el apego y recuperar tu centro.',
    value: 27,
    tag: 'GUÍA PRINCIPAL',
    icon: <BookOpen size={36} strokeWidth={1.5} data-id="element-362" />,
    gradient: 'from-primary to-accent',
    image: 'https://cdn.magicpatterns.com/uploads/exEs2zXyjTAnrajKJzWQbL/heylloyd-image-1777978394497.png'
  }, {
    title: 'Plan de Acción de 21 Días',
    desc: 'Calendario guiado para seguir el proceso paso a paso sin sentirte perdida ni abrumada. Tu hoja de ruta diaria.',
    value: 19,
    tag: 'IMPLEMENTACIÓN',
    icon: <CalendarDays size={36} strokeWidth={1.5} data-id="element-363" />,
    gradient: 'from-accent to-gold',
    image: 'https://cdn.magicpatterns.com/uploads/vTWqXxyKQZaDJrwFS4wLuE/heylloyd-image-1777978260830.png'
  }, {
    title: 'Kit de 21 Frases de Cierre',
    desc: 'Frases poderosas para repetir en momentos de ansiedad, nostalgia, recaída o impulso de volver a buscarlo.',
    value: 11,
    tag: 'HERRAMIENTA',
    icon: <Quote size={36} strokeWidth={1.5} data-id="element-364" />,
    gradient: 'from-relief to-primary',
    image: 'https://cdn.magicpatterns.com/uploads/kF6YS361Dphbxr3r1rDqPP/heylloyd-image-1777980245681.png'
  }];
  return <section className="py-24 px-4 bg-blush relative" data-id="element-365">
      <div className="max-w-4xl mx-auto" data-id="element-366">
        <div className="text-center mb-14" data-id="element-367">
          <span className="font-sans text-accent text-xs font-bold tracking-[0.25em] uppercase mb-3 block" data-id="element-368">
            ✦ El Sistema Completo ✦
          </span>
          <h2 className="font-serif font-bold text-3xl md:text-5xl text-primary mb-4" data-id="element-369">
            Todo lo que obtienes hoy:
          </h2>
        </div>

        <div className="space-y-6" data-id="element-370">
          {items.map((item, i) => <motion.div key={i} initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: i * 0.1
        }} className="bg-white rounded-2xl p-6 md:p-8 shadow-xl border border-soft/40 flex flex-col md:flex-row items-start md:items-center gap-6 hover:-translate-y-1 transition-transform" data-id="element-371">
              {item.image ? <div className="w-full md:w-44 aspect-[3/4] md:aspect-[3/4] rounded-xl overflow-hidden shrink-0 relative shadow-lg bg-blush" data-id="element-372">
                  <img src={item.image} alt={item.title} className="w-full h-full object-cover" data-id="element-373" />
                  <div className="absolute bottom-2 left-0 w-full text-center" data-id="element-374">
                    <span className="font-sans text-[9px] font-bold text-white/95 tracking-[0.2em] uppercase bg-primary/70 px-2 py-1 rounded backdrop-blur-sm" data-id="element-375">
                      {item.tag}
                    </span>
                  </div>
                </div> : <div className={`w-full md:w-44 aspect-[4/3] md:aspect-square rounded-xl bg-gradient-to-br ${item.gradient} flex items-center justify-center shrink-0 relative overflow-hidden shadow-lg`} data-id="element-376">
                  <div className="absolute inset-0 bg-[radial-gradient(circle_at_top_right,_rgba(255,255,255,0.25),_transparent_60%)]" data-id="element-377"></div>
                  <div className="text-white opacity-90 relative z-10" data-id="element-378">
                    {item.icon}
                  </div>
                  <div className="absolute bottom-3 left-0 w-full text-center" data-id="element-379">
                    <span className="font-sans text-[9px] font-bold text-white/80 tracking-[0.2em] uppercase" data-id="element-380">
                      {item.tag}
                    </span>
                  </div>
                </div>}

              <div className="flex-1" data-id="element-381">
                <div className="flex flex-wrap items-center justify-between gap-2 mb-3" data-id="element-382">
                  <h3 className="font-serif font-bold text-2xl md:text-3xl text-primary leading-tight" data-id="element-383">
                    {item.title}
                  </h3>
                  <div className="bg-urgency/10 text-urgency text-xs font-bold px-3 py-1.5 rounded-full border border-urgency/30 whitespace-nowrap" data-id="element-384">
                    Valor:{' '}
                    <span className="line-through font-extrabold" data-id="element-385">
                      ${item.value}
                    </span>
                  </div>
                </div>
                <p className="text-ink/80 font-sans leading-relaxed text-sm md:text-base" data-id="element-386">
                  {item.desc}
                </p>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}